<script>

export default {
  name: 'Car',


  props: {
    car: {
      type: Object,
      required: true
    },
    selectedCarSection: {
      type: Object
    }
  }

}
</script>

<template>
  <div class="car row">
    <div class="columns small-offset-1 small-22">
      <admin-edit :title="`${car.car_model.model_name} bearbeiten`" :url="`/pl/0/cars/${car.id}/edit`"></admin-edit>

      <img v-if="car.image" class="show-for-small-only" :src="car.image.url" :alt="car.car_model.model_name">

      <h3>{{ car.car_model.model_name }}</h3>

      <div class="row">
        <div class="columns medium-12">
          <p>
            {{ car.description }}
          </p>

          <car-features :car="car"></car-features>
        </div>
        <div v-if="car.image" class="columns medium-12 hide-for-small-only">
          <img :src="car.image.url" :alt="car.car_model.model_name">
        </div>

      </div>

      <pricing v-if="car.tariff" :tariff="car.tariff" :selectedCarSection="selectedCarSection"></pricing>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.car {
  margin-bottom: rem-calc(120);
  @include breakpoint(medium down) {
    margin-bottom: rem-calc(60);
  }
}
h3 {
  font-weight: bold;
  @include breakpoint(medium down) {
    font-size: rem-calc(20);
    line-height: rem-calc(40);
  }
  @include breakpoint(small only) {
    text-align: center;
  }
}
p {
  font-size: rem-calc(20);
  margin-bottom: rem-calc(40);
  @include breakpoint(medium down) {
    font-size: rem-calc(16);
    line-height: rem-calc(30);
  }
  @include breakpoint(small only) {
    margin-top: 0;
    margin-bottom: rem-calc(10);
    line-height: rem-calc(25)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Car.vue